module.exports = __webpack_public_path__ + "static/media/roemischesvorratslager_tn.d7c96fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/roemischesvorratslager_tn.jpg
// module id = 684
// module chunks = 0